import { getActiveFulfillmentCenter } from './fulfillmentCenterApi'

const selectedFulfillmentCenterKey = 'fulfillmentCenterSelected'

export const setFulfillmentCenterSelected = ({ name, id, is_market }) => {
  localStorage.setItem(selectedFulfillmentCenterKey, JSON.stringify({ name, id, is_market }))
}

export const getFulfillmentCenterSelected = () => {
  const fc = localStorage.getItem(selectedFulfillmentCenterKey)
  if (fc) {
    return JSON.parse(fc)
  }
  return
}

export const removeFulfillmentCenterSelected = () => {
  localStorage.removeItem(selectedFulfillmentCenterKey)
}

export const checkFulfillmentCenterSelected = async (loggedUser, onLogout) => {
  if (!loggedUser) {
    return
  }

  const fcSelected = getFulfillmentCenterSelected()

  if (!fcSelected) {
    onLogout()
    return
  }

  const result = await getActiveFulfillmentCenter()

  if (result.isOk) {
    const fcIsActive = result.data.data.some((fc) => fc.id === fcSelected.id)
    if (!fcIsActive) {
      onLogout()
    }
    return
  }

  if (loggedUser) {
    onLogout()
  }
}
